const toastr = require('../assets/vendors/toastr/toastr.min');
require('../assets/vendors/toastr/toastr.min.css');

const VueToastr = {};

VueToastr.install = function (Vue) {
  toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: 'toast-bottom-right',
    preventDuplicates: false,
    onclick: null,
    showDuration: '300',
    hideDuration: '1000',
    timeOut: '5000',
    extendedTimeOut: '1000',
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut',
  };
  Vue.prototype.$toastr = toastr;
};

export default VueToastr;



// WEBPACK FOOTER //
// ./src/plugins/vue-toastr.js